module.exports = __webpack_public_path__ + "static/img/son6_active.963a6639.png";